<template>
  <div v-if="this.$store.state.device.isDesktop">
    <navbarTop></navbarTop>
    <sideBar></sideBar>
    <div class="desktop_container">
      <div v-if="payment">

        <h5 style="text-align: left"><b>{{$t('pages.Menu.Payment')}}</b></h5>
        <hr style="background-color: #8D99AE; border: 1px solid #8D99AE">

        <div style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.PersonalData') }}</b></label></div>
        <br>
        <br>
        <b-row>
          <b-col :cols="width>1050 ? 4 : 6">
            <b-form-group>
              <legend>{{ $t('pages.Registration.Number') }}</legend>
              <b-form-input
                      disabled
                      v-model="row.number"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col :cols="width>1050 ? 4 : 6">
            <b-form-group>
              <legend>{{ $t('pages.Registration.Name') }}</legend>
              <b-form-input
                      disabled
                      v-model="row.name"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col v-if="width>1050" cols="4">
            <b-form-group>
              <legend>{{ $t('pages.Registration.Email') }}</legend>
              <b-form-input
                      disabled
                      v-model="row.email"
                      placeholder="example@example.pt"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col v-if="width<1050" cols="6">
            <b-form-group>
              <legend>{{ $t('pages.Registration.Email') }}</legend>
              <b-form-input
                      disabled
                      v-model="row.email"
                      placeholder="example@example.pt"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col :cols="width>1050 ? 4 : 6">
            <b-form-group>
              <legend>{{ $t('pages.Registration.BirthdayDate') }}</legend>
              <b-form-input
                      disabled
                      type="date"
                      v-model="row.birthday_date"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col :cols="width>1050 ? 4 : 6">
            <b-form-group>
              <legend>{{ $t('pages.Registration.Phone') }}</legend>
              <b-form-input
                      disabled
                      v-model="row.phone_number"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col :cols="width>1050 ? 4 : 6">
            <b-form-group>
              <legend>{{ $t('pages.Registration.Location') }}</legend>
              <b-form-input
                      disabled
                      v-model="row.address"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col :cols="width>1050 ? 4 : 6">
            <b-form-group>
              <legend>{{ $t('pages.List.ColumnNotes') }}</legend>
              <b-form-input
                      disabled
                      v-model="row.notes"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <legend>{{ $t('pages.Registration.MemberType') }}</legend>
              <b-form-input v-if="row.type==1" disabled placeholder="Normal"></b-form-input>
              <b-form-input v-if="row.type==2" disabled placeholder="Idoso"></b-form-input>
              <b-form-input v-if="row.type==3" disabled placeholder="Criança"></b-form-input>
              <b-form-input v-if="row.type==4" disabled placeholder="Atleta"></b-form-input>
              <b-form-input v-if="row.type==5" disabled placeholder="Mulher"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="1">
            <b-form-group v-if="row.status == 1">
              <legend>{{ $t('pages.List.ColumnStatus') }}</legend>
              <b-button class="status_flag_success">{{ $t('pages.List.Ok') }}</b-button>
            </b-form-group>
            <b-form-group v-if="row.status == 2">
              <legend>{{ $t('pages.List.ColumnStatus') }}</legend>
              <b-button class="status_flag_danger">{{ $t('pages.List.Delay') }}</b-button>
            </b-form-group>
          </b-col>
          <b-col cols="3" align-self="center" v-if="row.status == 2">
            <b-button v-if="row.send_alert_email == 0" class="btnSend" v-on:click="sendAlertEmail(row.number, row.email, row)">
              <img src="../../public/img/send.svg" style="width: 25%;">
              {{ $t('pages.List.notifyMember') }}
            </b-button>
            <b-button v-if="row.send_alert_email == 1" class="btnSend_disabled" v-on:click="toastAlertEmail(row)">
              <img src="../../public/img/send.svg" style="width: 25%;">
              {{ $t('pages.List.notifyMember') }}
            </b-button>
          </b-col>
        </b-row>
        <br>
        <div style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.PaymentTitle') }}</b></label></div>
        <br>
        <br>
        <b-row>
          <b-col :cols="width>1200 ? 4 : 6">
            <b-form-group>
              <legend style="margin-bottom: 5%">{{ $t('pages.Registration.MemberType') }}</legend>
              <b-form-input v-if="row.type==1" disabled placeholder="Normal"></b-form-input>
              <b-form-input v-if="row.type==2" disabled placeholder="Idoso"></b-form-input>
              <b-form-input v-if="row.type==3" disabled placeholder="Criança"></b-form-input>
              <b-form-input v-if="row.type==4" disabled placeholder="Atleta"></b-form-input>
              <b-form-input v-if="row.type==5" disabled placeholder="Mulher"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col :cols="width>1200 ? 4 : 6">
            <b-form-group>
              <legend>{{ $t('pages.Registration.PaymentLabel') }}</legend>
              <b-form-group style="margin-top: 5%;">
                <b-form-select style="width: 100%; border-radius: 32px;" v-model="selected" :options="options"></b-form-select>
              </b-form-group>
            </b-form-group>
          </b-col>
          <b-col :cols="width>1200 ? 4 : 0">
          </b-col>
        </b-row>
      </div>

      <div v-else>

        <h5 style="text-align: left"><b>{{$t('pages.Menu.Edit')}}</b></h5>
        <hr style="background-color: #8D99AE; border: 1px solid #8D99AE">

        <div style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.PersonalData') }}</b></label></div>
        <br>
        <br>
        <b-row>
          <b-col :cols="width>1050 ? 4 : 6">
            <b-form-group>
              <legend>{{ $t('pages.Registration.Number') }}</legend>
              <b-form-input
                      disabled
                      v-model="row.number"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col :cols="width>1050 ? 4 : 6">
            <b-form-group>
              <legend>{{ $t('pages.Registration.Name') }}</legend>
              <b-form-input
                      v-model="row.name"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col v-if="width>1050" cols="4">
            <b-form-group>
              <legend>{{ $t('pages.Registration.Email') }}</legend>
              <b-form-input
                      v-model="row.email"
                      placeholder="example@example.pt"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col v-if="width<1050" cols="6">
            <b-form-group>
              <legend>{{ $t('pages.Registration.Email') }}</legend>
              <b-form-input
                      v-model="row.email"
                      placeholder="example@example.pt"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col :cols="width>1050 ? 4 : 6">
            <b-form-group>
              <legend>{{ $t('pages.Registration.BirthdayDate') }}</legend>
              <b-form-input
                      type="date"
                      v-model="row.birthday_date"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col :cols="width>1050 ? 4 : 6">
            <b-form-group>
              <legend>{{ $t('pages.Registration.Phone') }}</legend>
              <VuePhoneNumberInput default-country-code="PT" v-model="row.phone_number" />
            </b-form-group>
          </b-col>
          <b-col :cols="width>1050 ? 4 : 6">
            <b-form-group>
              <legend>{{ $t('pages.Registration.Location') }}</legend>
              <gmap-autocomplete
                      :placeholder="row.address"
                      :options="autocompleteOptions"
                      @place_changed="setPlace"
                      class="form-control input"
                      style="width: 100%">
              </gmap-autocomplete>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col :cols="width>1050 ? 4 : 6">
            <b-form-group>
              <legend>{{ $t('pages.List.ColumnNotes') }}</legend>
              <b-form-input
                      v-model="row.notes"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <legend>{{ $t('pages.Registration.MemberType') }}</legend>
              <b-form-select style="border-radius: 32px; border: 1px solid #8D99AE !important;" v-model="row.type" :options="options_type"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="1">
            <b-form-group v-if="row.status == 1">
              <legend>{{ $t('pages.List.ColumnStatus') }}</legend>
              <b-button class="status_flag_success">{{ $t('pages.List.Ok') }}</b-button>
            </b-form-group>
            <b-form-group v-if="row.status == 2">
              <legend>{{ $t('pages.List.ColumnStatus') }}</legend>
              <b-button class="status_flag_danger">{{ $t('pages.List.Delay') }}</b-button>
            </b-form-group>
          </b-col>
          <b-col cols="3" v-if="row.status == 2">
            <b-form-group v-if="row.send_alert_email == 0">
              <legend></legend>
              <b-button class="btnSend" v-on:click="sendAlertEmail(row.number, row.email, row)">
                <img src="../../public/img/send.svg" style="width: 25%;">
                {{ $t('pages.List.notifyMember') }}
              </b-button>  
            </b-form-group>
            <b-form-group v-if="row.send_alert_email == 1">
              <legend></legend>
              <b-button class="btnSend_disabled" v-on:click="toastAlertEmail(row)">
                <img src="../../public/img/send.svg" style="width: 25%;">
                {{ $t('pages.List.notifyMember') }}
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>

      </div>

      <div class="footer_desktop">
        <hr class="bottom_line">
        <div class="footer_content_left">
          <a v-on:click="openModal(row.number, row)" style="text-decoration: underline; color: #1e90ff;">{{$t('pages.List.deleteMember')}}</a>
        </div>
        <div class="footer_content_right">
          <a v-on:click="back" style="text-decoration: underline;">{{ $t('standard.back') }}</a>
          <b-button id="nextDesktop" v-on:click="submit(row)">{{ $t('standard.Submit') }}</b-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import NavbarTop from "../components/navbarTop";
  import navbarBottom from "../components/navbarBottom";
  import sideBar from "../components/sideBar";
  import VuePhoneNumberInput from "vue-phone-number-input";
  import {configValues} from "../api/Config/apiConfig.js";
  import {newPayment} from "../api/Payment/apiPayment.js";
  import {updateMember, deleteMember, sendAlertEmail} from "../api/Member/apiMember.js";
  const pt = require('../translations/pt-PT/pt-PT');
  const en = require('../translations/en-GB/en-GB');

  export default{
    name: "edit",
    components: {
      NavbarTop, navbarBottom, sideBar, VuePhoneNumberInput
    },
    props: ['row', 'payment'],
    data() {
      return {
        width: null,
        selected: 0,
        options: [],
        options_type: [],
        address: '',
        autocompleteOptions: {
          componentRestrictions: {
            country: [
              'pt',
            ],
          },
        }
      };
    },
    methods: {
      submit: function(row) {
        if(this.payment) this.makePayment(row);
        else this.updateSocio(row);
      },
      makePayment: function(row) {
        if(this.selected>0) {
          let spinner = this.$loading.open();
          configValues()
                  .then(response => {
                    let value = null;
                    if(row.type==1) value=response.data.body[0].fee_value_default;
                    if(row.type==2) value=response.data.body[0].fee_value_elderly;
                    if(row.type==3) value=response.data.body[0].fee_value_child;
                    if(row.type==4) value=response.data.body[0].fee_value_athlete;
                    if(row.type==5) value=response.data.body[0].fee_value_woman;
                    let payment = {
                      number: row.number,
                      number_of_payments_year: this.selected,
                      value: this.selected * value
                    };
                    newPayment(payment)
                            .then(response => {
                              let members = JSON.parse(localStorage.getItem('members'));
                              for(var i=0; i<members.length; i++) {
                                  if(members[i].number == row.number) {
                                    members[i].number_of_payments_year += this.selected;
                                    members[i].send_alert_email = 0;
                                    //Calculate status
                                    let month = new Date().getMonth()+1;
                                    if(members[i].number_of_payments_year >= month) members[i].status = 1;
                                    else members[i].status = 2;
                                  }
                              }
                              localStorage.setItem('members', JSON.stringify(members));

                              spinner.close();
                              this.$toast.open({message: "Sócio "+row.number+": Pagamento Realizado", duration: 5000});
                              this.$router.push('/listPayments');
                            })
                            .catch(error => {
                              spinner.close();
                              let response_error = error.response.data;
                              this.$toast.open({message: response_error[Object.keys(response_error)[0]].msg.code, type: 'is-danger'});
                            });
                  })
                  .catch(error => {spinner.close();this.$toast.open({message: "Algo correu mal", type: 'is-danger'});})
        } else {this.$toast.open({message: "Insira o pagamento a efetuar", type: 'is-danger'});}
      },
      back: function() {
        this.$router.go(-1);
      },
      setPlace(place) {
        this.address = place.name;
      },
      updateSocio: function(row) {
        let address='';
        if(this.address=='') address=row.address
        else address=this.address
        let update_data = {
          name: row.name,
          birthday_date: row.birthday_date,
          phone_number: row.phone_number,
          address: address,
          member_email: row.email,
          notes: row.notes,
          type: row.type
        };
        let spinner = this.$loading.open();
        updateMember(row.number, update_data)
                .then(response => {
                  let members = JSON.parse(localStorage.getItem('members'));
                  members.forEach(obj => {
                      if(obj.number == row.number) {
                        obj.name = row.name;
                        obj.birthday_date = row.birthday_date;
                        obj.phone_number = row.phone_number;
                        obj.address = address;
                        obj.email = row.email;
                        obj.notes = row.notes;
                        obj.type = row.type;
                      }
                  })
                  localStorage.setItem('members', JSON.stringify(members));
                  spinner.close();
                  if(this.$i18n.locale()=='pt') {this.$toast.open(pt.pages.List.messageUpdate); this.$router.push('/listSocios');}
                  if(this.$i18n.locale()=='en') {this.$toast.open(en.pages.List.messageUpdate); this.$router.push('/listSocios');}
                })
                .catch(error => {
                  spinner.close();
                  if (!error.response) this.$toast.open({message: "O servidor não está a responder...", type: 'is-danger'});
                  else{
                    let response_error = error.response.data;
                    this.$toast.open({message: response_error[Object.keys(response_error)[0]].msg.code, type: 'is-danger'});
                  }
                });
      },
      openModal(number, row) {
        if(this.$i18n.locale()=='pt'){
          this.$bvModal.msgBoxConfirm(pt.pages.List.confirmModal, {
            title: pt.pages.List.titleModal+''+number,
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: pt.pages.List.oktitleModal,
            cancelTitle: pt.pages.List.canceltitleModal,
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          })
                  .then(value => {
                    if(value) this.deleteSocio(number);
                  })
                  .catch(error => { })
        }else if(this.$i18n.locale()=='en'){
          this.$bvModal.msgBoxConfirm(en.pages.List.confirmModal, {
            title: en.pages.List.titleModal+''+number,
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: en.pages.List.oktitleModal,
            cancelTitle: en.pages.List.canceltitleModal,
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          })
                  .then(value => {
                    if(value) this.deleteSocio(number);
                  })
                  .catch(error => { })
        }
      },
      deleteSocio(number) {
        let spinner = this.$loading.open();
        deleteMember(number)
                .then(response => {
                  spinner.close();
                  if (response.data.body.changedRows == 1) {
                    let members = JSON.parse(localStorage.getItem('members'));
                    for(var i=0; i<members.length; i++) {
                        if(members[i].number == number) members.splice(i,1);   
                    }
                    localStorage.setItem('members', JSON.stringify(members));

                    if(this.$i18n.locale()=='pt') this.$toast.open(pt.pages.List.messageDelete);
                    if(this.$i18n.locale()=='en') this.$toast.open(en.pages.List.messageDelete);
                    this.$router.push('/listSocios');
                  } else {
                    this.$toast.open({
                      message: 'Algo não correu bem. Tente novamente',
                      type: 'is-danger'
                    })
                  }
                })
                .catch(error => {
                  console.log(error);
                  spinner.close();
                  if (!error.response) this.$toast.open({message: "O servidor não está a responder...", type: 'is-danger'});
                  else{
                    let response_error = error.response.data;
                    this.$toast.open({
                      message: response_error[Object.keys(response_error)[0]].msg.code,
                      type: 'is-danger',
                    });
                  }
                })
      },
      toastAlertEmail(row) {
        if(this.$i18n.locale()=='pt'){
          this.$toast.open({
            message: pt.pages.List.messageAlreadyNotify,
            duration: 3500,
            type: 'is-danger'
          });
        } else if(this.$i18n.locale()=='en'){
          this.$toast.open({
            message: en.pages.List.messageAlreadyNotify,
            duration: 3500,
            type: 'is-danger'
          });
        }
      },
      sendAlertEmail(number, email, row){
        let data = {};
        data.number = number;
        data.email = email;
        let spinner = this.$loading.open();
        sendAlertEmail(data)
                .then((response) => {
                  let members = JSON.parse(localStorage.getItem('members'));
                  members.forEach(obj => {
                      if(obj.number == number) {
                        obj.send_alert_email = 1;
                      }
                  })
                  localStorage.setItem('members', JSON.stringify(members));
                  spinner.close();
                  if(this.$i18n.locale()=='pt'){
                    this.$toast.open({
                      message: pt.pages.List.messageSent,
                      duration: 3500,
                    });
                    this.$router.go(-1);
                  } else if(this.$i18n.locale()=='en'){
                    this.$toast.open({
                      message: en.pages.List.messageSent,
                      duration: 3500,
                    });
                    this.$router.go(-1);
                  }
                })
                .catch(error => {
                  spinner.close();
                  if (!error.response) this.$toast.open({message: "O servidor não está a responder...", type: 'is-danger'});
                  else{
                    let response_error = error.response.data;
                    this.$toast.open({message: response_error[Object.keys(response_error)[0]].msg.code, type: 'is-danger'});
                  }
                })
      }
    },
    mounted() {
      //Prevent page reload without associated member
      if(this.row == null) this.$router.push('/listSocios');

      this.width = Math.max(self.innerWidth || 0, document.documentElement.clientWidth || 0, document.body.clientWidth || 0);

      let spinner = this.$loading.open();

      if(this.$i18n.locale()=='pt') {
        this.options_type = [{ value: 1, text: pt.pages.Registration.TypeNormal },
          { value: 2, text: pt.pages.Registration.TypeElderly },
          { value: 3, text: pt.pages.Registration.TypeChild },
          { value: 4, text: pt.pages.Registration.TypeAthlete },
          { value: 5, text: pt.pages.Registration.TypeWoman }]
      }
      if(this.$i18n.locale()=='en') {
        this.options_type = [{ value: 1, text: pt.pages.Registration.TypeNormal },
          { value: 2, text: en.pages.Registration.TypeElderly },
          { value: 3, text: en.pages.Registration.TypeChild },
          { value: 4, text: en.pages.Registration.TypeAthlete },
          { value: 5, text: en.pages.Registration.TypeWoman }]
      }
      if(this.$i18n.locale()=='pt') {
        this.options = [{ value: 0, text: pt.pages.Registration.PaymentDropNoPayment },
          { value: 1, text: pt.pages.Registration.PaymentDropMonth },
          { value: 3, text: pt.pages.Registration.PaymentDropTrimester },
          { value: 6, text: pt.pages.Registration.PaymentDropSemester },
          { value: 12, text: pt.pages.Registration.PaymentDropYear }]
      }
      if(this.$i18n.locale()=='en') {
        this.options = [{ value: 0, text: en.pages.Registration.PaymentDropNoPayment },
          { value: 1, text: en.pages.Registration.PaymentDropMonth },
          { value: 3, text: en.pages.Registration.PaymentDropTrimester },
          { value: 6, text: en.pages.Registration.PaymentDropSemester },
          { value: 12, text: en.pages.Registration.PaymentDropYear }]
      }

      spinner.close();
    }
  };
</script>

<style>
  #nextDesktop {
    background: #2B2D42 0% 0% no-repeat padding-box;
    border-radius: 32px;
    color: white;
    border: none;
    letter-spacing: 0.85px;
    margin-left: 20px;
  }
  legend {
    color: #2B2D42;
    text-align: left;
    font-size: 100% !important;
    letter-spacing: 0.8px;
    margin-bottom: 2%;
  }
  input {
    border: 1px solid #8D99AE !important;
    border-radius: 22px !important;
    -webkit-box-shadow: 0 0 3px #8D99AE !important;
    -moz-box-shadow: 0 0 3px #8D99AE !important;
    box-shadow: 0 0 3px #8D99AE !important;
  }
  .status_flag_success {
    float: left;
    background-color: #23d160 !important;
    border-color: #23d160 !important;
    border-radius: 22px !important;
  }
  .status_flag_danger {
    float: left;
    background-color: #ff3860 !important;
    border-color: #ff3860 !important;
    border-radius: 22px !important;
  }
  .btnSend {
    background: #ffffff 0% 0% no-repeat padding-box !important;
    border-radius: 32px !important;
    color: #2B2D42 !important;
    border-color: #2B2D42 !important;
    letter-spacing: 0.85px !important;
    float: right;
    margin-top: 1.5vh !important;
  }
  .btnSend_disabled {
    background: #cccccc 0% 0% no-repeat padding-box !important;
    border-radius: 32px !important;
    color: #2B2D42 !important;
    border-color: #2B2D42 !important;
    letter-spacing: 0.85px !important;
    float: right;
    margin-top: 1.5vh !important;
  }
</style>
